import { AuthService } from "../../../../services/auth.service"
import { ApiService } from "../../../../services/api.service"
import { getRoleSetState } from "./index"
import { navigate } from "@reach/router"
import * as decode from "jwt-decode"
import { toast } from "react-toastify"

/**
 * @function initiateLogin - Function to initiate the login process
 * @param e - Event, used here to prevent the form default behavior
 * @param email - The user's email address
 * @param password - The user's password
 * @param setState - hook to set the Auth context state
 * @param logout - function to log the user out
 * @param removeCookie - hook to remove cookie
 * @param isAdminLogin - boolean to determine if this is an admin login
 */
export const initiateLogin = (
  e,
  email,
  password,
  setState,
  setCookie,
  logout,
  removeCookie,
  isAdminLogin = false
) => {
  e.preventDefault()
  setState(prevState => ({ ...prevState, loading: true }))
  AuthService.login(email, password, isAdminLogin).then((res: any) => {
    if (res.status === 200) {
      if (res.data.passwordExpireInDays > 0) {
      res.data.authToken &&
        setCookie("hallenToken", res.data.authToken, {
          maxAge: 3600,
          path: "/",
        })
      const { name, roleId, userID, empID } = decode(res.data.authToken)
      const employeeParams = new URLSearchParams({
        employeeID: "me",
      })
      ApiService.get(process.env.EMPLOYEE_DETAIL, employeeParams).then(
        (response: any) => {
          if (response.status === 200) {
            setState(prevState => ({
              ...prevState,
              employeeDetails: { ...response.data.data[0] },
            }))
          }
        }
      )
      getRoleSetState(
        name,
        roleId,
        userID,
        empID,
        setState,
        logout,
        res.data.authToken,
        removeCookie
      ).then(() => {
        navigate(sessionStorage.getItem('targetUrl') || "/dashboard")
      })
      } else {
        setState(prevState => ({
          ...prevState,
          loading: false
        }))
        toast.error("Your password has expired. Please reset your password in order to proceed.")
      }
    } else if (res.status === 401) {
      setState(prevState => ({
        ...prevState,
        message: {
          text: "Username or password is incorrect",
          variant: "danger",
        },
        loading: false,
      }))
    } else {
      let errMessage = res && res.data && res.data.Message
      errMessage = errMessage || "Something went wrong. Please try again later."
      setState(prevState => ({
        ...prevState,
        message: { text: errMessage, variant: "danger" },
        loading: false,
      }))
    }
  })
}
